import { create } from "zustand";

export type Theme = "day" | "dark";

const STORAGE_KEY = "shift_manager.theme";

function readStored(): Theme {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v === "day" || v === "dark") return v;
  } catch { /* localStorage blocked; default to day */ }
  return "day";
}

function apply(t: Theme) {
  const root = document.documentElement;
  if (t === "dark") root.classList.add("dark");
  else root.classList.remove("dark");
  try { localStorage.setItem(STORAGE_KEY, t); } catch { /* noop */ }
}

interface ThemeState {
  theme: Theme;
  setTheme: (t: Theme) => void;
  toggle: () => void;
}

// Read + apply the stored theme synchronously at module load so
// the correct background paints on first render instead of
// flashing the default light theme before the hook kicks in.
const initial = readStored();
apply(initial);

export const useTheme = create<ThemeState>((set, get) => ({
  theme: initial,
  setTheme: (theme) => { apply(theme); set({ theme }); },
  toggle: () => {
    const next: Theme = get().theme === "dark" ? "day" : "dark";
    apply(next);
    set({ theme: next });
  },
}));
